export const getStaticStateClasses = (classes, height) => (
  [
    classes.static,
    height === 0 && classes.staticHeightZero,
    typeof height === 'number' && height > 0
      ? classes.staticHeightSpecific
      : null,
    height === 'auto' && classes.staticHeightAuto,
  ].filter((v) => v).join(' ')
);

export const updateDisplayStyle = (element, newHeight, property = '') => {
  const node = element;
  if (newHeight === 0 && element?.style) {
    node.style.display = property;
  }
};
